import React from 'react';
import PropTypes from 'prop-types';

const CircleMinus = ({ color }) => (
  <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none">
    <path
      d="M9 11C8.44772 11 8 11.4477 8 12C8 12.5523 8.44772 13 9 13H15C15.5523 13 16 12.5523 16 12C16 11.4477 15.5523 11 15 11H9Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4Z"
      fill={color}
    />
  </svg>
);

CircleMinus.propTypes = {
  color: PropTypes.string.isRequired,
};

export default CircleMinus;
